<template>
  <fn-link
    :id="contentTile.tracking_id || undefined"
    :to="isNuxtLink(contentTile.link.url)"
    :href="isHrefLink(contentTile.link.url)"
    :target="contentTile.link.target"
    :data-name="recoName"
    :data-audience="recoAudience"
    class="content-tile"
    :class="{
      'content-tile--reco': recommendation,
      'content-tile--no-pointer': !contentTile.link,
    }"
    no-arrow
    no-hover
    :static="!contentTile.link"
  >
    <fn-picture
      v-if="contentTile.background_image"
      :src="contentTile.background_image.url"
      :width="contentTile.background_image.width"
      :height="contentTile.background_image.height"
      :alt="contentTile.background_image.alt"
      :title="contentTile.background_image.title"
      class="ct-image"
    />

    <div
      class="ct-text-overlay"
      :class="{
        'ct-text-overlay--bottom': contentTile.text_overlay_style === 'bottom',
        'ct-text-overlay--full-height': contentTile.text_overlay_style === 'full-height',
        'ct-text-overlay--no-text': hideText,
        'ct-text-overlay--reco': recommendation,
      }"
    >
      <fn-headline
        v-if="!hideText"
        type="div"
        :size="contentTile.text_overlay_style === 'full-height' ? 'h2' : 'h5'"
        class="ct-title"
        v-html="contentTile.title"
      />

      <div
        v-if="!hideText"
        class="ct-text"
        v-html="contentTile.text"
      />

      <fn-button
        v-if="contentTile.button_style !== 'no-button'"
        :id="contentTile.tracking_id || undefined"
        :secondary="contentTile.button_style === 'green'"
        :quaternary="contentTile.button_style === 'white'"
        :full-width="!recommendation"
        :data-name="recoName"
        :data-audience="recoAudience"
        static
        class="ct-button"
      >
        {{ contentTile.link.title }}
      </fn-button>
    </div>
  </fn-link>
</template>

<script>
import linkHandler from '@/mixins/linkHandler';

export default {
  mixins: [linkHandler],
  props: {
    contentTile: {
      type: Object,
      required: true,
    },
    recommendation: {
      type: Boolean,
    },
    recoName: {
      type: String,
      default: null,
    },
    recoAudience: {
      type: String,
      default: null,
    },
  },
  computed: {
    hideText() {
      return this.contentTile.text_overlay_style === 'no-text' || this.recommendation;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-tile {
  display: block;
  position: relative;
  width: 100%;
  min-height: 300px;
  grid-row: span 20;
  height: 100%;
  border-radius: map-get($border-radiuses, 'l');
  overflow: hidden;
}

.content-tile--reco {
  @include subgrid-span-rows(20);
  height: 100%;
  border-radius: map-get($border-radiuses, 'xl');
  overflow: hidden;
  box-sizing: border-box;
  margin-top: 0;

  @include bp(s) {
    height: 100%;
  }
}

.content-tile--no-pointer {
  cursor: default;
}

.ct-image :deep(.picture-img) {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

.ct-text-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgba(palette(sand, light), 0.8);
  padding: $pad;
  box-sizing: border-box;

  &.ct-text-overlay--full-height {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    .ct-button {
      margin-top: $pad;
    }
  }

  &.ct-text-overlay--bottom {
    .ct-title {
      font-weight: initial;
      margin-bottom: math.div($pad, 3);
    }

    .ct-button {
      margin-top: math.div($pad, 2);
    }
  }

  &.ct-text-overlay--no-text {
    background: transparent;
  }

  &.ct-text-overlay--reco {
    padding: 0;
    align-items: flex-start;
    justify-content: flex-end;
  }
}
</style>
